
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/active-directory-sync",
      function () {
        return require("private-next-pages/learn/active-directory-sync.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/active-directory-sync"])
      });
    }
  